import React from 'react';

import './Section.css';

const Section = props =>
  <div id={props.id} className={`section ${props.style}`}>
    {props.children}
  </div>

export default Section;


// WEBPACK FOOTER //
// ./src/common/Section.js